<i class="far fa-question-circle" alt="Ajuda" (click)="open()">
  <vn-modal [id]="id" title="{{'globals.ajuda' | translate}}" [large]="'small'" movible>
    <ng-container>
      <label class="ajuda-titol" *ngIf="titol!=null"><u>{{titol}}</u></label>
      <div class="ajuda-contingut">
        <ng-content></ng-content>
      </div>
    </ng-container>
    <div class="button-bar">
      <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
    </div>
  </vn-modal>
</i>